<template>
  <div class="zoom">
    <div class="hand1" ref="hand1" v-parallax-fit="hand1"></div>
    <div class="hand2" v-parallax-fit="hand2"></div>
    <div class="hand3" v-parallax-fit="hand3"></div>
  </div>

</template>

<script>
export default {
  name: 'slide17',
  data() {
    return {
		mutationObserver: null,
      hand1: [
        {
          start: 16600,
          end: 17000,
          fromStyle: { transform: 'translateX(-1260px) rotate(-13deg)' },
          toStyle: { transform: 'translateX(0px) rotate(-13deg)' },
          easing: 'linear'
        },
        {
          start: 18600,
          end: 19100,
          fromStyle: { transform: 'translateX(0px) rotate(-13deg)' },
          toStyle: { transform: 'translateX(-1260px) rotate(-13deg)' },
          easing: 'linear'
        },
      ],
      hand2: [
        {
          start: 17100,
          end: 17500,
          fromStyle: { transform: 'translateX(1260px) translateY(-700px) rotate(-40deg)' },
          toStyle: { transform: 'translateX(0px) translateY(0px) rotate(-40deg)' },
          easing: 'linear'
        },
        {
          start: 18600,
          end: 19100,
          fromStyle: { transform: 'translateX(0px) translateY(0px) rotate(-40deg)' },
          toStyle: { transform: 'translateX(1260px) translateY(-700px) rotate(-40deg)' },
          easing: 'linear'
        },
      ],
      hand3: [
        {
          start: 17600,
          end: 18000,
          fromStyle: { transform: 'translateX(0px) translateY(1400px) rotate(180deg)' },
          toStyle: { transform: 'translateX(0px) translateY(0px) rotate(180deg)' },
          easing: 'linear'
        },
        {
          start: 18600,
          end: 19100,
          fromStyle: { transform: 'translateX(0px) translateY(0px) rotate(180deg)' },
          toStyle: { transform: 'translateX(0px) translateY(1400px) rotate(180deg)' },
          easing: 'linear'
        },
      ]
    };
  },
  mounted() {
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/9.jpg',
          url: 'https://www.responsiblelending.org/research-publication/effects-california-foreclosure-crisis',
          link_title: {
			'en': 'Effects of the California Foreclosure Crisis on African Americans and Latinos',
			'es': 'Efectos de la Crisis de las Ejecuciones Hipotecarias de California en los Afroamericanos y Latinos'
		  }
        },
      ],
      text: {
		'en': '"Nationally, [up until 2012] approximately 15 percent of higher-income Latino borrowers and 10 percent of higher-income African-American borrowers [had] lost their home to foreclosure, compared with 4.6 percent of higher-income non-Hispanic white borrowers."<br /><b>From: Effects of the California Foreclosure Crisis on African Americans and Latinos, June 2012 Center for Responsible Lending</b>',
		'es': '"A nivel nacional, [hasta 2012] aproximadamente el 15 por ciento de los prestatarios latinos de ingresos más altos y el 10 por ciento de los prestatarios afroamericanos de ingresos más altos [habían] perdido su casa por ejecución hipotecaria, en comparación con el 4,6 por ciento de los prestatarios blancos no hispanos de ingresos más altos. ."<br /><b>De: Efectos de la crisis de ejecuciones hipotecarias de California en afroamericanos y latinos, junio de 2012 Centro para préstamos responsables</b>'
	  }
    };

    const text = {
		'en': 'During the height of the foreclosure crisis in 2012, a higher national percentage of Black and Latino homeowners had their homes taken through foreclosure. In California alone, Black and Latino borrowers were twice as likely to experience foreclosure due to being targeted for high-risk loans.',
		'es': 'Durante el punto álgido de la crisis de ejecuciones hipotecarias en 2012, un porcentaje nacional más alto de propietarios negros y latinos fueron embargados. Solo en California, los prestatarios negros y latinos tenían el doble de probabilidades de sufrir una ejecución hipotecaria debido a que eran objeto de préstamos de alto riesgo.'
	};
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateX(0px) rotate(-13deg)') {
          this.$evidence.value = JSON.stringify(evidence);
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(this.$refs.hand1, {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
}
</script>

<style lang="scss" scoped>
.hand1 {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/17_CorporateHand.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 940px;
    height: 300px;
    left: calc(50% - 989px);
    top: calc(50% - 50px);
    transition: 0.3s;
    z-index: 10;
    transform: rotate(-130deg);
}
.hand2 {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/17_CorporateHand_1.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 940px;
    height: 300px;
    left: calc(50% + 114px);
    top: calc(50% - 568px);
    transition: 0.3s;
    z-index: 12;
    transform: rotate(-40deg);
    @media(max-width: 600px) {
      left: calc(50% - 16px);
      top: calc(50% - 428px);
    }
}
.hand3 {
    position: fixed;
    transform-origin: center;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_Hand_1.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 300px;
    height: 950px;
    left: calc(50% - 33px);
    top: calc(50% + 7px);
    transition: 0.3s;
    z-index: 12;
    transform: rotate(180deg);
}
</style>
